'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var accounts = require('../accounts.cjs');
var errors = require('../errors.cjs');
var AuctionHouse = require('../models/AuctionHouse.cjs');
var Operation = require('../../../types/Operation.cjs');

// -----------------
// Operation
// -----------------

const Key = 'FindAuctionHouseByAddressOperation';

/**
 * Finds an Auction House by its address.
 *
 * ```ts
 * const nft = await metaplex
 *   .auctionHouse()
 *   .findByAddress({ address };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findAuctionHouseByAddressOperation = Operation.useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findAuctionHouseByAddressOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      programs,
      commitment
    } = scope;
    const {
      address,
      auctioneerAuthority
    } = operation.input;
    const auctioneerPda = auctioneerAuthority ? metaplex.auctionHouse().pdas().auctioneer({
      auctionHouse: address,
      auctioneerAuthority,
      programs
    }) : undefined;
    const accountsToFetch = [address, auctioneerPda].filter(account => !!account);
    const accounts$1 = await metaplex.rpc().getMultipleAccounts(accountsToFetch, commitment);
    scope.throwIfCanceled();
    const auctionHouseAccount = accounts.toAuctionHouseAccount(accounts$1[0]);
    const mintModel = await metaplex.tokens().findMintByAddress({
      address: auctionHouseAccount.data.treasuryMint
    }, scope);
    scope.throwIfCanceled();
    if (!auctionHouseAccount.data.hasAuctioneer) {
      return AuctionHouse.toAuctionHouse(auctionHouseAccount, mintModel);
    }
    if (!accounts$1[1] || !accounts$1[1].exists) {
      throw new errors.AuctioneerAuthorityRequiredError();
    }
    const auctioneerAccount = accounts.toAuctioneerAccount(accounts$1[1]);
    return AuctionHouse.toAuctionHouse(auctionHouseAccount, mintModel, auctioneerAccount);
  }
};

exports.findAuctionHouseByAddressOperation = findAuctionHouseByAddressOperation;
exports.findAuctionHouseByAddressOperationHandler = findAuctionHouseByAddressOperationHandler;
//# sourceMappingURL=findAuctionHouseByAddress.cjs.map
